/** a golden laurel branch: a curved stem with slim alternating leaves, mirrored for the right side of a badge */
export function Laurel({ mirrored = false, size = 36, color = '#E5B400' }: { mirrored?: boolean; size?: number; color?: string }) {
  const stem = (t: number) => ({ x: 20 - 14 * t + 4 * t * t, y: 38 - 34 * t });
  const tangent = (t: number) => {
    const a = stem(t);
    const b = stem(Math.min(1, t + 0.02));
    return (Math.atan2(b.y - a.y, b.x - a.x) * 180) / Math.PI;
  };
  const leaves = [0.1, 0.24, 0.38, 0.52, 0.66, 0.8, 0.92].map((t, i) => {
    const p = stem(t);
    const side = i % 2 === 0 ? 1 : -1;
    const angle = tangent(t) + side * 40;
    const normal = ((tangent(t) + 90) * Math.PI) / 180;
    const cx = p.x + Math.cos(normal) * side * 2.6;
    const cy = p.y + Math.sin(normal) * side * 2.6;
    return <ellipse key={i} cx={cx} cy={cy} rx={6 - t * 1.5} ry={2.1} fill={color} transform={`rotate(${angle} ${cx} ${cy})`} />;
  });
  return (
    <svg viewBox="0 0 24 40" width={size * 0.6} height={size} aria-hidden="true" style={{ flex: 'none', transform: mirrored ? 'scaleX(-1)' : undefined }}>
      <path d="M20 38 Q 10 30, 10 4" fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
      {leaves}
    </svg>
  );
}
